// canvas-store.js — 用户主动选择、可带入后续 Agent 任务的会话素材。
const listeners = new Set();
let state = { artifacts: [] };

export function getCanvasState() { return state; }

export function addArtifact(artifact) {
  if (!artifact?.id || state.artifacts.some((item) => String(item.id) === String(artifact.id))) return;
  state = { artifacts: [...state.artifacts, artifact] };
  emit();
}

export function removeArtifact(artifactId) {
  const artifacts = state.artifacts.filter((item) => String(item.id) !== String(artifactId));
  if (artifacts.length === state.artifacts.length) return;
  state = { artifacts };
  emit();
}

export function retainSessionArtifacts(sessionId) {
  const artifacts = state.artifacts.filter((item) => String(item.sessionId) === String(sessionId));
  if (artifacts.length === state.artifacts.length) return;
  state = { artifacts };
  emit();
}

export function clearCanvas() {
  if (!state.artifacts.length) return;
  state = { artifacts: [] };
  emit();
}

export function subscribe(listener) {
  listeners.add(listener);
  listener(state);
  return () => listeners.delete(listener);
}

function emit() {
  for (const listener of listeners) listener(state);
}

export const canvasStore = Object.freeze({ getCanvasState, addArtifact, removeArtifact, retainSessionArtifacts, clearCanvas, subscribe });
